import React from 'react';
import { HomeContainer } from './styles';
import { WelcomeSection } from './components/WelcomeSection';
import { ActionCards } from './components/ActionCard';

export const Home: React.FC = () => {
  return (
    <HomeContainer>
      <WelcomeSection />
      <ActionCards />
    </HomeContainer>
  );
};
